type SeoData = {
  schemaId?: string;
};

type ConfigSeoData = {
  schemaId?: string;
};

export type SchemaIds = {
  id?: string;
  base: string;
  orgId?: string;
};

const prepIds = (seo?: SeoData, configSeo?: ConfigSeoData): SchemaIds => {
  const [base] = configSeo?.schemaId?.split('#') || [];
  return {
    id: seo?.schemaId ? `${base}#${seo?.schemaId}` : undefined,
    base: base || '',
    orgId: configSeo?.schemaId,
  };
};

export default prepIds;
